/**
 * contains all the mobile-based views to composite them so that you call the same functions for all of them
 */
import {
    ISpinButtonView, SpinButtonBaseViewMobile,
    SpinButtonView,
    SpinButtonViewMobileLandscape,
    SpinButtonViewMobilePortrait
} from '@gongxigames/framework/slot/modules/spinbutton';
import {DeviceType} from '@gongxigames/framework/core';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {ScreenOrientedView} from '@gongxigames/framework/slot/fragments/module/view';

export class SpinButtonViewMobile extends ScreenOrientedView<GlobalEventsMapForBackwardCompatibility, SpinButtonView> implements
    ISpinButtonView {
    public static readonly NAME: symbol = Symbol('SpinButtonViewMobile');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected landscapeViewName: symbol = SpinButtonViewMobileLandscape.NAME;
    protected portraitViewName: symbol = SpinButtonViewMobilePortrait.NAME;

    public setSprite(name: string): void {
        this._views.forEach((view: SpinButtonView) => {
            (view as SpinButtonBaseViewMobile).setSprite(name);
        });
    }

    public spinButtonClickAction(): void {
        this._views.forEach((view: SpinButtonView) => {
            view.spinButtonClickAction();
        });
    }

    public enableSpinButton(): void {
        this._views.forEach((view: SpinButtonView) => {
            view.enableSpinButton();
        });
    }

    public disableSpinButton(): void {
        this._views.forEach((view: SpinButtonView) => {
            view.disableSpinButton();
        });
    }

    public enableSpinsLeftButton(): void {
        this._views.forEach(view => {
            (view as SpinButtonBaseViewMobile).enableSpinsLeftButton();
        });
    }

    public disableSpinsLeftButton(): void {
        this._views.forEach(view => {
            (view as SpinButtonBaseViewMobile).disableSpinsLeftButton();
        });
    }

    public initFreeSpins(): void {
        this._views.forEach(view => {
            view.initFreeSpins();
        });
    }

    public initMainGame(): void {
        this._views.forEach(view => {
            view.initMainGame();
        });
    }

    public initAutoplay(): void {
        this._views.forEach((view: SpinButtonView) => {
            view.initAutoplay();
        });
    }

    public uninitAutoplay(): void {
        this._views.forEach((view: SpinButtonView) => {
            view.uninitAutoplay();
        });
    }

    public onSpinStarted(): void {
        this._views.forEach((view: SpinButtonView) => {
            view.onSpinStarted();
        });
    }

    public isSpinButtonEnabled(): boolean {
        let isEnable = true;

        this._views.forEach((view: SpinButtonView) => {
            isEnable = isEnable && view.isSpinButtonEnabled(); // TODO: check this
        });

        return isEnable;
    }

    public enableHold(): void {
        this._views.forEach(view => {
            (view as SpinButtonBaseViewMobile).enableHold();
        });
    }

    public disableHold(): void {
        this._views.forEach(view => {
            (view as SpinButtonBaseViewMobile).disableHold();
        });
    }
}
